(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["niya-cod-availability"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalize = (value) => String(value || '').trim().replace(/\s+/g, ' ').toUpperCase();
    const list = (value) => new Set(String(value || '').split(/[\n,;]+/).map(normalize).filter(Boolean));
    const cityList = (value) => new Set(
      String(value || '').split(/[\n,;]+/)
        .map((entry) => entry.split('|').map(normalize).filter(Boolean).join('|'))
        .filter(Boolean),
    );

    const evaluate = (input, rules) => {
      const pincode = String(input.pincode || '').replace(/\D/g, '').slice(0, 6);
      const city = normalize(input.city);
      const state = normalize(input.state);
      const hasValidPin = /^[1-9]\d{5}$/.test(pincode);

      if (hasValidPin && rules.denyPins.has(pincode)) return { status: 'deny', reason: 'exact_pin' };
      if (hasValidPin && rules.allowPins.has(pincode)) return { status: 'allow', reason: 'exact_pin' };
      if (!city || !state) return { status: 'manual', reason: hasValidPin ? 'unmatched_pin' : 'invalid_pin' };

      const cityKey = `${state}|${city}`;
      if (rules.denyCities.has(cityKey) || rules.denyCities.has(city)) return { status: 'deny', reason: 'city' };
      if (rules.denyStates.has(state)) return { status: 'deny', reason: 'state' };
      if (rules.allowCities.has(cityKey) || rules.allowCities.has(city)) return { status: 'allow', reason: 'city' };
      if (rules.allowStates.has(state)) return { status: 'allow', reason: 'state' };
      return { status: rules.defaultResult, reason: 'default' };
    };

    const rulesFor = (root) => ({
      allowPins: list(root.dataset.allowPins),
      denyPins: list(root.dataset.denyPins),
      allowStates: list(root.dataset.allowStates),
      denyStates: list(root.dataset.denyStates),
      allowCities: cityList(root.dataset.allowCities),
      denyCities: cityList(root.dataset.denyCities),
      defaultResult: ['allow', 'deny'].includes(root.dataset.defaultResult) ? root.dataset.defaultResult : 'review',
    });

    if (!window.customElements || customElements.get('niya-cod-availability')) return;

    customElements.define('niya-cod-availability', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mounted === 'true') return;
        this.dataset.mounted = 'true';
        this.form = this.querySelector('form');
        this.pinInput = this.form.elements.namedItem('pincode');
        this.cityInput = this.form.elements.namedItem('city');
        this.stateInput = this.form.elements.namedItem('state');
        this.manual = this.querySelector('.niya-cod-availability__manual');
        this.manualToggle = this.querySelector('.niya-cod-availability__manual-toggle');
        this.result = this.querySelector('.niya-cod-availability__result');
        this.rules = rulesFor(this);
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.check(false);
        });
        this.querySelector('[data-check-manual]').addEventListener('click', () => this.check(true));
        this.manualToggle.addEventListener('click', () => this.setManual(this.manual.hidden));
        this.pinInput.addEventListener('input', () => {
          this.pinInput.value = this.pinInput.value.replace(/\D/g, '').slice(0, 6);
          this.clearResult();
        });
        this.cityInput.addEventListener('input', () => this.clearResult());
        this.stateInput.addEventListener('input', () => this.clearResult());
      }

      setManual(open) {
        this.manual.hidden = !open;
        this.manualToggle.setAttribute('aria-expanded', String(open));
        if (open) this.cityInput.focus();
      }

      clearResult() {
        this.result.hidden = true;
        this.result.textContent = '';
        this.result.removeAttribute('data-kind');
      }

      check(includeManual) {
        const decision = evaluate({
          pincode: this.pinInput.value,
          city: includeManual ? this.cityInput.value : '',
          state: includeManual ? this.stateInput.value : '',
        }, this.rules);
        if (decision.status === 'manual') {
          this.setManual(true);
          this.show(decision.reason === 'invalid_pin' ? this.dataset.invalidPinMessage : this.dataset.manualRequiredMessage, 'neutral');
          return;
        }
        if (decision.status === 'allow') this.show(this.dataset.availableMessage, 'success');
        else if (decision.status === 'deny') this.show(this.dataset.unavailableMessage, 'error');
        else this.show(this.dataset.reviewMessage, 'neutral');
      }

      show(message, kind) {
        this.result.textContent = message;
        this.result.dataset.kind = kind;
        this.result.hidden = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["niya-editorial-home-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-rail-control]');
    if (!control) return;
    const section = control.closest('.niya-home-v2__collection');
    const rail = section?.querySelector('.niya-home-v2__rail');
    if (!rail) return;
    const direction = control.dataset.railControl === 'next' ? 1 : -1;
    rail.scrollBy({ left: rail.clientWidth * 0.82 * direction, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
